import { render, staticRenderFns } from "./tongueReportConfig.vue?vue&type=template&id=4f6fc0c5&scoped=true&"
import script from "./tongueReportConfig.vue?vue&type=script&lang=ts&"
export * from "./tongueReportConfig.vue?vue&type=script&lang=ts&"
import style0 from "./tongueReportConfig.vue?vue&type=style&index=0&id=4f6fc0c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6fc0c5",
  null
  
)

export default component.exports